import React from 'react'
import styled from 'styled-components'
import { arrayOf, bool, object, string } from 'prop-types'

import { useToggle } from 'hooks/useToggle'
import TarifaPlanoModal from '../TarifaPlanoModal'

import { title14Galano } from '../../../styles/settings/types'
import { linkNavyBlue } from '../../../styles/settings/colors'
import rem from '../../../styles/tools/rem'

const LinkTarifa = styled.button`
  ${title14Galano} color: ${props => props.color || linkNavyBlue};
  font-size: ${rem('12px')};
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  margin: ${rem('8px')} 0;
  padding: 0;
  text-align: left;
  text-decoration: underline;
  text-indent: 0;
`

const TarifaPlanoLink = ({ tarifas, color, destaque, mostrarTabelaRecarga }) => {
  const [isOpen, toggle] = useToggle(false)

  if (!tarifas || tarifas.length === 0) {
    return null
  }

  return (
    <React.Fragment>
      <LinkTarifa type="button" color={color} onClick={toggle}>
        Conheça as tarifas do plano
      </LinkTarifa>
      {isOpen && (
        <TarifaPlanoModal
          tarifas={tarifas}
          hideModal={toggle}
          destaque={destaque}
          mostrarTabelaRecarga={mostrarTabelaRecarga}
        />
      )}
    </React.Fragment>
  )
}

TarifaPlanoLink.propTypes = {
  tarifas: arrayOf(object),
  color: string,
  destaque: string,
  mostrarTabelaRecarga: bool
}

TarifaPlanoLink.defaultProps = {
  tarifas: [],
  color: linkNavyBlue,
  destaque: '',
  mostrarTabelaRecarga: false
}

export default TarifaPlanoLink
